"use client";
import React, { createContext, useContext, useState, useCallback } from "react";
import { BASE_URL } from "../config/config";

const SupportTicketContext = createContext();

export const SupportTicketProvider = ({ children }) => {
  const [supportTickets, setSupportTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const getToken = () => {
    if (typeof window !== 'undefined') {
      return localStorage.getItem("token");
    }
    return null;
  };

  // 🔹 FETCH SUPPORT TICKETS (Read Only)
  const fetchSupportTickets = useCallback(async () => {
    const token = getToken();
    if (!token) return;

    setLoading(true);
    setError("");

    try {
      const res = await fetch(`${BASE_URL}/support`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (res.ok && data.status === 200) {
        setSupportTickets(data.data || []);
      } else {
        setError(data.message || "Failed to fetch support tickets");
      }
    } catch (err) {
      setError("Network error");
      console.error("Fetch support tickets error:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  // 🔹 GET SINGLE SUPPORT TICKET (Read Only)
  const getSupportTicket = async (id) => {
    const token = getToken();
    if (!token) return null;

    try {
      const res = await fetch(`${BASE_URL}/support/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await res.json();

      if (res.ok && data.status === 200) {
        return data.data;
      } else {
        setError(data.message || "Failed to fetch support ticket");
        return null;
      }
    } catch (err) {
      setError("Network error");
      console.error("Get support ticket error:", err);
      return null;
    }
  };

  // inside SupportTicketProvider

// 🔹 UPDATE SUPPORT TICKET STATUS
const updateTicketStatus = async (id, status) => {
  const token = getToken();
  if (!token || !id || !status) return false;

  try {
    const user = JSON.parse(localStorage.getItem("user") || "{}");

    const res = await fetch(`${BASE_URL}/support/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        id,
        status,
        update_audit_id: user.id
      }),
    });

    const data = await res.json();

    if (res.ok && data.status === 200) {
      // Optionally refresh tickets after update
      await fetchSupportTickets();
      return true;
    } else {
      console.error(data.message || "Failed to update status");
      return false;
    }
  } catch (err) {
    console.error("Update ticket status error:", err);
    return false;
  }
};


  return (
    <SupportTicketContext.Provider
      value={{
        supportTickets,
        loading,
        error,
        fetchSupportTickets,
        getSupportTicket,
        updateTicketStatus,
      }}
    >
      {children}
    </SupportTicketContext.Provider>
  );
};

export const useSupportTickets = () => {
  const context = useContext(SupportTicketContext);
  if (!context) {
    throw new Error("useSupportTickets must be used within a SupportTicketProvider");
  }
  return context;
};
